<template>
  <default-modal ref="box" :title="`设置直连模式和备用远程`" :modalWidth="600" :confirmTxt="`保存`" @confirm="confirm">
    <div class="modal-body">
      <div class="step step-top">
        <p>
          设置直连和备用远程，够获得更快的远程速度，更好的远程画质，更快的文件传输速度，更好的安全性，永远不用担心
          3389 和 Radmin 密码泄露而被恶意连接。
        </p>
      </div>
      <div class="step">
        <h5>步骤一：</h5>
        <p>
          请在本网吧的路由器上将 主服务器<span v-show="mainBsLocalIp" v-text="'（' + mainBsLocalIp + '）'"></span>的 19680 和 19682
          两个端口映射到外网，即可实现直连所有服务器，且可正常使用
          3389 和 Radmin 备用远程。
        </p>
      </div>
      <div class="step">
        <h5>步骤二：</h5>
        <p>
          请将步骤一设置的信息填入下表中。
        </p>
        <div>
          <div class="row">
            <span class="left">外网访问地址：</span>
            <select name="autoType" v-model="autoType">
              <option value="0">手动获取</option>
              <option value="1">自动获取</option>
            </select>
            <input class="default-input" :class="{ first: autoType === 0 }" v-show="autoType === '0'" type="text"
              v-model="wanip" />
          </div>
          <div class="row">
            <span class="left">权限验证端口：</span>
            <span>内网端口 19680 映射为：</span>
            <input class="default-input" type="text" v-model="vport" />
          </div>
          <div class="row">
            <span class="left">远程代理端口：</span>
            <span>内网端口 19682 映射为：</span>
            <input type="text" class="default-input" v-model="pport" />
          </div>
          <div class="row">
            <span class="left">服务器3389开关：</span>
            <select name="mstscSwitch" v-model="mstscSwitch">
              <option value="0">禁用</option>
              <option value="1">开启</option>
            </select>
          </div>
          <div class="row">
            <span class="left">服务器Radmin状态：</span>
            <span v-show="!radminState">
              <img src="@/assets/img/icon/u2236.png" alt="" class="img" />
              未安装
            </span>
            <span v-show="radminState">已安装</span>
          </div>
        </div>
      </div>
    </div>
  </default-modal>
</template>
<script>
import DefaultModal from "_c/modals/defaultModal";

import { getBarRemoteInfo, updateBarRemoteInfo } from "@/requests/bar";
export default {
  components: {
    DefaultModal
  },
  data () {
    return {
      autoType: "", //0：手动获取 1：自动获取
      wanip: "", //外网ip
      vport: "", //权限设置ip
      pport: "", //远程代理端口
      mstscSwitch: "", //3389开关 0：禁用 1：开启
      radminState: false, //Radmin状态
      mainBsLocalIp: ""
    };
  },
  methods: {
    // 初始化信息
    async init () {
      this.$refs.box.clearWrong();
      this.autoType = "";
      this.wanip = "";
      this.vport = "";
      this.pport = "";
      this.mstscSwitch = "";
      this.radminState = false;
      this.mainBsLocalIp = "";
      let res = await getBarRemoteInfo({
        barId: this.$route.params.id
      });
      if (res)
      {
        this.autoType = res.autoType === null ? "" : res.autoType + "";
        this.wanip = res.wanip === null ? "" : res.wanip;
        this.vport = res.vport === null ? "" : res.vport;
        this.pport = res.pport === null ? "" : res.pport;
        this.mstscSwitch =
          res.mstscSwitch === null ? "" : res.mstscSwitch + "";
        this.radminState =
          res.radminState === null ? false : res.radminState;
        this.mainBsLocalIp =
          res.mainBsLocalIp === null ? "" : res.mainBsLocalIp;
      }

      this.$refs.box.show();
    },
    async confirm () {
      this.$refs.box.clearWrong();
      if (this.autoType.trim() === "")
      {
        return this.$refs.box.setWrong("请选择外网访问地址方式");
      }
      if (this.vport.trim() === "")
      {
        return this.$refs.box.setWrong("请输入权限验证端口");
      }
      if (this.pport.trim() === "")
      {
        return this.$refs.box.setWrong("请输入远程代理端口");
      }
      if (this.mstscSwitch.trim() === "")
      {
        return this.$refs.box.setWrong("请选择服务器3389开关");
      }
      let res = await updateBarRemoteInfo({
        barId: this.$route.params.id,
        autoType: this.autoType,
        wanip: this.wanip,
        vport: this.vport,
        pport: this.pport,
        mstscSwitch: this.mstscSwitch
      });
      if (res.code == 200)
      {
        this.$refs.box.hide();
      } else
      {
        this.$refs.box.setWrong(res.msg);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "_style/_color.scss";

.modal-body {
  padding: 10px;
  padding-left: 30px;
  padding-right: 30px;
  text-align: left;

  .step {
    h5 {
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      line-height: 24px;
      padding-top: 6px;
      padding-bottom: 6px;
    }

    p {
      text-indent: 2em;
      line-height: 20px;
    }

    .row {
      height: 31px;
      line-height: 31px;
      margin-top: 10px;
      overflow: hidden;
      margin-left: 60px;

      select {
        width: 100px;
        height: 30px;
        border: 1px solid rgba(230, 230, 230, 1);
        outline: none;
        margin-right: 5px;
      }

      input {
        width: 125px;
        padding-left: 10px;
        background: #fff;
      }

      input.first {
        background: rgba(242, 242, 242, 1);
      }

      .img {
        position: relative;
        top: 3px;
      }

      .left {
        display: inline-block;
        float: left;
        min-width: 116px;
        margin-right: 10px;
        color: $gray-word;
        text-align: right;
      }
    }
  }
}

.step-top {
  padding-left: 5px;
  border: 1px solid rgb(251, 236, 203);
  background-color: rgb(252, 248, 226);
  color: rgb(246, 131, 0);
}
</style>
